import {
  Button,
  Card,
  Col,
  Form,
  Image,
  Input,
  Layout,
  Row,
  message,
} from 'antd';
import React, { useEffect } from 'react';
import { Images } from '../../../controller/Images';
import {
  isAdminLoggedIn,
  setAdminDetail,
  setAdminRefreshToken,
  setAdminToken,
} from '../../../controller/localStroageHandler';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { login } from '../../../controller/api/authServices'
const { Header, Content } = Layout;
const Login = () => {
  const [formRef] = Form.useForm(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (isAdminLoggedIn()) {
      navigate(-1);
    }
  }, []);
  const handleSubmit = async (val) => {
    await login(val).then(res => {
      const { email, id, lastName, firstName, organization_id, phoneNo, role, tokens } = res.data.result
      setAdminDetail({ email, id, lastName, firstName, organization_id, phoneNo, role })
      setAdminToken(tokens.token)
      setAdminRefreshToken(tokens.refreshtoken)
      navigate(routes.admin.dashboard.candidates);
      message.success(res?.data?.message)
    }).catch(err => {
      message.error(err.response?.data?.message)
      // formRef.resetFields()
      console.log("err ===>", err.response?.data?.message)
    })
  };
  return (
    <Layout className='w-100 h-100  '>
      <Header className='bg-white p-3'>
        <Image className='logo' src={Images.logo} alt='' height={50} preview={false} />
      </Header>
      <Content className='h-100 w-100 d-flex justify-content-center align-items-center bg-white'>
        <Row className='w-100'>
          <Col span={24}>
            <Row gutter={[0, 20]} justify={'center'} className='text-center'>
              <Col span={24} className='d-flex flex-column'>
                <span className='fs-2 fw-bold'>Welcome</span>
                <span className='fs-5 text-muted fw-semibold'>Admin Login</span>
              </Col>
              <Col xs={18} sm={13} md={10} lg={6} className='text-start'>
                <Form
                  form={formRef}
                  onFinish={handleSubmit}
                  className='d-flex flex-column gap-1'
                >
                  <Form.Item
                    name='userName'
                    rules={[
                      {
                        required: true,
                        message: 'Enter you Email',
                      },
                    ]}
                  >
                    <Input size='large' placeholder='User ID' />
                  </Form.Item>
                  <Form.Item
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: 'Enter you Password',
                      },
                      {
      pattern: /^\S*$/,
      message: 'Password must not contain spaces',
    }
                    ]}
                  >
                    <Input.Password size='large' placeholder='Password' />
                  </Form.Item>
                  <Form.Item className='text-center'>
                    <Button
                      className='w-75 button-color'
                      type='primary'
                      size='large'
                      htmlType='submit'
                    >
                      Login
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Login;
